import Section from '../../Common/Section/Section'
import './AboutSection.css'

function AboutSection() {
    return (
        <Section id={"about-section"}>
            <div className='about-container'>
                <div className='about-section-container'>
                    <img src='/images/about-image.jpg' id='about-image' alt='Trisha Somers' />
                    <div className='about-text-container'>
                        <h3>Meet Trisha</h3>
                        <p>I help people calm their mind, clear mental noise, and release what’s weighing on them, so they can see their next step with clarity and confidence.</p>
                        <p>Most of the people I work with are capable, responsible, and deeply committed. Over time, carrying that much responsibility creates mental clutter, emotional weight, and constant pressure. When clarity fades, even meaningful work can start to feel heavy.</p>
                        <p>My work is grounded and thoughtful, shaped by years of helping people slow down, gain perspective, and reconnect with their own insight.</p>
                        <p>I believe clarity doesn’t come from doing more or fixing yourself.
                            It comes from creating space — to be heard, to reflect, and to let the noise settle.
                        </p>
                    </div>
                </div>
                <div className='about-section-container'>
                    <div className='about-text-container'>
                        <h3>Working With Me</h3>
                        <p>Working with me is a calm, focused, and collaborative experience.</p>
                        <p>I don’t push, fix, or overwhelm you with strategies. I create space for the mental and emotional noise to settle so clarity can emerge naturally.</p>
                        <p>People often come to me feeling overloaded or unclear and leave feeling lighter, steadier, and able to see their next step without force.</p>
                        <p>The focus isn’t on doing more, it’s on creating the conditions where insight and direction return.</p>
                        <p>Clarity and regulation come first; action follows naturally.</p>
                        <div className='calendly-link'>
                            <h4>Want to learn more?</h4>
                            <a className='button apply-button' href={"https://calendly.com/trishasomerscoaching/30min"} target='new'>Connection call</a>
                        </div>
                    </div>
                    <img src='/images/about-image-2.jpg' id='about-image' alt='Trisha Somers' />
                </div>
            </div>
        </Section>
    )
}

export default AboutSection